<a
  #skipLink
  class="skip-link"
  href="#main-content"
  (click)="skipToMain($event)"
  data-cy="skip-to-main">
  Skip to main content
</a>

<mat-sidenav-container
  class="app-container"
  [class.landing]="isLandingPage()"
  utScreenSize>
  <mat-sidenav
    #sidenav
    class="navigation-drawer"
    mode="over"
    data-cy="psu-sidenav">
    @if (!isLandingPage()) {
      <div class="navigation-drawer-content">
        <div class="drawer-header">
          <button
            type="button"
            mat-icon-button
            (click)="sidenav.close()"
            aria-label="Close Navigation Drawer"
            data-cy="close-nav-drawer-button">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <mat-nav-list>
          @for (navigationItem of navigationItems; track navigationItem.path) {
            <a
              mat-list-item
              #drawerLink="routerLinkActive"
              ariaCurrentWhenActive="page"
              [routerLink]="navigationItem.path"
              routerLinkActive="link-active"
              [activated]="drawerLink.isActive"
              (click)="sidenav.close()"
              [attr.data-cy]="`nav-${navigationItem.path}`">
              <mat-icon
                matListItemIcon
                [class.icon-filled]="drawerLink.isActive"
                >{{ navigationItem.icon }}</mat-icon
              >
              <span>{{ navigationItem.label }}</span>
            </a>
          }
        </mat-nav-list>

        <div class="drawer-theme-toggle">
          <button
            class="theme-switcher-button"
            type="button"
            mat-button
            [matMenuTriggerFor]="themeMenu"
            data-cy="toggle-theme-drawer-button"
            [attr.aria-label]="'Theme: ' + themeLabel() + '. Click to change theme.'">
            <mat-icon>{{ themeIcon() }}</mat-icon>
            {{ themeLabel() }}
          </button>
        </div>
      </div>
    }
  </mat-sidenav>

  <mat-sidenav-content class="app-frame">
    @if (!isLandingPage()) {
      <nav
        class="navigation-rail"
        aria-label="Primary navigation">
        <div class="rail-menu-container">
          <button
            type="button"
            mat-icon-button
            (click)="sidenav.open()"
            aria-label="Open Navigation Drawer"
            data-cy="open-nav-drawer-button">
            <mat-icon>menu</mat-icon>
          </button>
        </div>

        <div class="rail-nav-list">
          @for (navigationItem of navigationItems; track navigationItem.path) {
            <a
              #railLink="routerLinkActive"
              class="rail-nav-item"
              ariaCurrentWhenActive="page"
              [routerLink]="navigationItem.path"
              routerLinkActive="link-active"
              [attr.data-cy]="`nav-${navigationItem.path}-rail`">
              <span class="rail-icon-container">
                <mat-icon [class.icon-filled]="railLink.isActive">{{ navigationItem.icon }}</mat-icon>
              </span>
              <span class="rail-label">{{ navigationItem.label }}</span>
            </a>
          }
        </div>

        <button
          class="rail-theme-button"
          type="button"
          mat-icon-button
          [matMenuTriggerFor]="themeMenu"
          [matTooltip]="'Theme: ' + themeLabel()"
          matTooltipPosition="after"
          [attr.aria-label]="'Theme: ' + themeLabel() + '. Click to change theme.'"
          data-cy="toggle-theme-button">
          <mat-icon>{{ themeIcon() }}</mat-icon>
        </button>
      </nav>
    }

    <div class="page-shell">
      <mat-toolbar
        class="toolbar"
        data-cy="psu-toolbar">
        @if (!isLandingPage() && isMobileLayout()) {
          <button
            type="button"
            mat-icon-button
            (click)="sidenav.open()"
            aria-label="Open Navigation Drawer"
            data-cy="open-nav-drawer-mobile-button">
            <mat-icon>menu</mat-icon>
          </button>
        }
        <a
          class="psu-link"
          href="https://www.psu.edu/"
          utExternalLink
          aria-label="Penn State home page"
          data-cy="psu-header">
          <img
            class="toolbar-logo"
            [src]="logoPath() | psuCdn"
            alt="Penn State mark"
            data-cy="psu-logo" />
        </a>
        @if (!isLandingPage()) {
          <div class="header-text-container">
            <span class="header-title">Student Success Role Management</span>
            <span class="header-subtitle">Roles, relationships, and access for Navigate360 and Elevate</span>
          </div>
        }
      </mat-toolbar>

      <main
        #mainContentArea
        id="main-content"
        tabindex="-1">
        <div class="main-scroll-container">
          <router-outlet />
        </div>
      </main>

      @if (isLandingPage()) {
        <div class="landing-footer">
          <uic-footer
            class="psuFooter"
            [logoLarge]="logoPath() | psuCdn"
            [logoMobile]="logoPath() | psuCdn"
            year="2026" />
        </div>
      }
    </div>
  </mat-sidenav-content>

  <mat-menu #themeMenu="matMenu">
    <button
      mat-menu-item
      type="button"
      (click)="setTheme('light')"
      [attr.aria-current]="themeMode() === 'light' ? 'true' : null">
      <mat-icon>light_mode</mat-icon>
      <span class="theme-menu-item-label">
        Light
        @if (themeMode() === 'light') {
          <mat-icon class="selected-indicator">check</mat-icon>
        }
      </span>
    </button>
    <button
      mat-menu-item
      type="button"
      (click)="setTheme('dark')"
      [attr.aria-current]="themeMode() === 'dark' ? 'true' : null">
      <mat-icon>dark_mode</mat-icon>
      <span class="theme-menu-item-label">
        Dark
        @if (themeMode() === 'dark') {
          <mat-icon class="selected-indicator">check</mat-icon>
        }
      </span>
    </button>
    <button
      mat-menu-item
      type="button"
      (click)="setTheme('auto')"
      [attr.aria-current]="themeMode() === 'auto' ? 'true' : null">
      <mat-icon>brightness_auto</mat-icon>
      <span class="theme-menu-item-label">
        Auto
        @if (themeMode() === 'auto') {
          <mat-icon class="selected-indicator">check</mat-icon>
        }
      </span>
    </button>
  </mat-menu>
</mat-sidenav-container>
